import React, { ReactElement } from "react";
import { StepProps } from "../TradeModal";
import LoadingBlock from "components/Loading/LoadingBlock";
import { useQueryBundle } from "source/hooks";
import { AccountStatusType } from "$gql/types.gen";
import { GetAccountStatus } from "$gql/queries/tradier/GetAccountStatus.gen";

export default function CheckAccountStatus(props: StepProps): ReactElement {
  props.setTitle(`Connecting to ${props.state.brokerName}`);

  const accountStatusQuery = useQueryBundle(GetAccountStatus, {
    variables: { institutionLoginId: props.state.institutionLoginId },
    fetchPolicy: "no-cache",
  });

  if (accountStatusQuery.state !== "DONE") {
    return <LoadingBlock />;
  }

  const status =
    accountStatusQuery.data.getInstitutionLogin?.brokerAccountStatus;

  if (!status) {
    throw new Error("Error retreiving account status");
  }

  if (status === AccountStatusType.Connected) {
    props.dispatch({ type: "authenticatedAccount" });
  }

  if (status === AccountStatusType.Disconnected) {
    props.dispatch({ type: "needsOAuth" });
  }

  if (status === AccountStatusType.BrokerAccountError) {
    props.dispatch({ type: "needsFurtherAction" });
  }

  return <LoadingBlock />;
}
